const devApiUrl = "https://localhost:8080/mcols/api/";

const { _env_ }: any = window;
export const API_URL = _env_ ? _env_.API_URL : devApiUrl;
export const WSO2_LOGIN_URL = `${API_URL}oauth2/authorize/ws02`;
export const WSO2_LOGOUT_URL = `${API_URL}oauth2/logout/ws02`;
